import { Component, input } from '@angular/core'
import { Comment } from 'superlikers-microsites-api'

import { Participant } from '@core/data'
import { ParticipantAvatarPipe } from '@shared/pipes'

@Component({
  selector: 'app-comment-card',
  imports: [ParticipantAvatarPipe],
  templateUrl: './comment-card.html'
})
export class CommentCard {
  comment = input.required<Comment<Participant>>()
}
